import { SET_WIDGET_CLASSES } from '../actions/types';

export default function widgetClasses(state = '', action = null) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_WIDGET_CLASSES:
				return action.payload;
			default:
				return state;
		}
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/widgetClasses.js